import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectWorkersInfo } from "../../selectors/selectWorkersInfo";
import { HOCHudComponent } from "../context-menu/HOCHudComponent";
import { componentFromType } from "../generic/componentFromType";
import { HudStatBar } from "../generic/hud-stat-bar/HudStatBar";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLocaValueProportional } from "../generic/text/TextLocaValueProportional";
import { IdTooltipAnchor, withDynamicTooltip } from "../tooltip";
import { HudWorkerTooltip } from "./HudWorkerTooltip";
var _HudWorkers = function (_a) {
    var free = _a.free, total = _a.total;
    return (React.createElement(HudStatBar, { icon: "" + IdIcon.WorkersIcn, styleId: IdStyles.IconMedium, backgroundSize: "small", backgroundClassName: IdStyles.HudStat, className: "hud-stat-bar" },
        React.createElement(TextLocaValueProportional, { className: IdStyles.TextBoldSecondaryOutline, available: free, required: total })));
};
export var HudWorkers = connect(selectWorkersInfo)(HOCHudComponent(withDynamicTooltip({
    anchor: IdTooltipAnchor.TopLeft,
    component: componentFromType(HudWorkerTooltip),
})(_HudWorkers)));



//////////////////
// WEBPACK FOOTER
// ./src/features/workers/HudWorkers.tsx
// module id = 2309
// module chunks = 3